module.exports = __webpack_public_path__ + "img/gao-yue.acecbfca.jpeg";